import { BaseModel } from "sjs-base-model";

export default class OneriFormModel extends BaseModel {
    public readonly oneri: string = "";

    constructor(data: Partial<OneriFormModel>) {
        super();

        this.update(data);
    }
}
